import React, { useState } from 'react'
import { List } from 'immutable'
import DropInVideoPlayer, { DEFAULT_CONTROLS } from '../DropInVideoPlayer/index'
import { VA_SHARE_PLAYER_TYPE } from '../../services/video-analytics/index'
import { TYPE_CONTENT_VIDEO } from '../../services/content-type/index'

/**
 * The video player component
 * @param {Map} props.auth - The auth
 * @param {Map} props.share - The share data
 * @param {Map} props.error - The error data
 * @param {String} props.language - The user's language
 * @param {Function} props.onVideoEnded - The video playback end handler
 * @param {Function} props.onVideoViewed - The video viewed by user handler
 * @param {Function} props.onVideoPaused - The video paused handler
 * @param {Function} props.onVideoResumed - The video resumed handler
 * @returns {JSX.Element} VideoPlayer component
 */
function SharePageVideoPlayer (props) {
  const {
    share,
    language,
    onVideoEnded,
    onVideoViewed,
    onVideoPaused,
    onVideoResumed,
  } = props

  const [playerReady, setPlayerReady] = useState(false)
  const media = share.get('fullMedia')

  if (!media) {
    return null
  }

  const contentId = share.get('contentId')
  const textTracks = media.get('textTracks')
  const srcsByLang = media.getIn(['mediaUrls', 'byLang'], List())
  const foreignDub = srcsByLang.find((src, l) => l === language)
  const mediaURL = foreignDub || media.getIn(['mediaUrls', 'bcHLS'])
  const mediaId = media.get('mediaId')
  const mediaDuration = media.getIn(['mediaUrls', 'duration'])
  const mediaLanguage = media.getIn(['mediaUrls', 'language'])

  const playerContainerClassName = [
    'share-page__video-player-container',
    playerReady ? null : 'share-page__video-player-container--hidden',
  ].filter((cls) => !!cls).join(' ')

  let ga4EventData = {
    media_id: mediaId,
    media_language: mediaLanguage,
    content_id: contentId,
    content_name: share.getIn(['content', 'title']),
    content_type: TYPE_CONTENT_VIDEO,
    is_featured_media: !!share.get('sharable'),
    click_attribution: 'Share',
  }
  if (share.getIn(['content', 'seriesId'])) {
    ga4EventData = {
      ...ga4EventData,
      parent_series_id: share.getIn(['content', 'seriesId']),
      parent_series_name: share.getIn(['content', 'seriesTitle']),
    }
  }

  return (
    <div className="share-page__video-player">
      <div className={playerContainerClassName}>
        <DropInVideoPlayer
          qualifyViewsAction={onVideoViewed}
          handleVideoEnd={onVideoEnded}
          handleVideoPaused={onVideoPaused}
          handleVideoPlay={onVideoResumed}
          onPlayerSuccess={() => setPlayerReady(true)}
          controls={{ type: DEFAULT_CONTROLS }}
          textTracks={textTracks}
          audioTracks={srcsByLang}
          playerSrc={mediaURL}
          mediaId={mediaId}
          videoId={contentId}
          mediaDuration={mediaDuration}
          mediaLanguage={mediaLanguage}
          enableVideoAnalytics={mediaDuration > 0}
          videoAnalyticsPlayerType={VA_SHARE_PLAYER_TYPE}
          ga4EventData={ga4EventData}
          userLanguage={language}
          starOnCanPlay
          playsinline
          enableMediaCenter
        />
      </div>
    </div>
  )
}

export default SharePageVideoPlayer
